export default {
    methods: {
        calculatePercentage(credit, balance) {
            if (credit != null) {
              return ((credit / balance) * 100).toFixed(0);
            }
            return 0
        },
    }
}